import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var receiptIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1188-263H252v1709h-1440z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.25 14.5H6V14c0-.552.336-1 .75-1H21v.5c0 .552-.336 1-.75 1zm.167 3H14V17c0-.274.062-.53.173-.71a.817.817 0 0 1 .145-.182.386.386 0 0 1 .227-.108H21v.5c0 .268-.061.546-.178.726a.767.767 0 0 1-.156.18.416.416 0 0 1-.25.094z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.25 3.25H1.75a1.5 1.5 0 0 0-1.5 1.5v14.5a1.5 1.5 0 0 0 1.5 1.5h20.5a1.5 1.5 0 0 0 1.5-1.5V4.75a1.5 1.5 0 0 0-1.5-1.5zm-20.5 1.5h20.5v14.5H1.75V4.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 6.25h-3.5a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h3.5a1.5 1.5 0 0 0 1.5-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5zm-3.5 1.5h3.5v1.5h-3.5v-1.5z"
}))));

export { receiptIcon as default };
//# sourceMappingURL=receiptIcon.js.map
